// Offerings filter helpers — coach / date / sport / level (all default to "All").
import { SPORT_META, useSport } from "@/context/SportContext";

export const DATE_RANGES = [
  { v: "", l: "All dates" },
  { v: "today", l: "Today" },
  { v: "week", l: "This week" },
  { v: "7", l: "Next 7 days" },
  { v: "30", l: "Next 30 days" },
  { v: "day", l: "Pick a day…" },
];

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function matchesDate(o, range, day) {
  if (!range) return true;
  if (!o.start) return false;
  const d = new Date(o.start);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (range === "today") return ymd(d) === ymd(today);
  if (range === "day") return !day || ymd(d) === day;
  if (range === "week") {
    const end = new Date(today);
    end.setDate(today.getDate() + (7 - ((today.getDay() + 6) % 7)));
    return d >= today && d < end;
  }
  const end = new Date(today);
  end.setDate(today.getDate() + Number(range) + 1);
  return d >= today && d < end;
}

const sel = "bg-[#0A0A0A] border border-[#262626] px-3 py-1.5 text-sm focus:border-[#CCFF00] focus:outline-none";

export function OfferingFilters({ items, f, setF }) {
  const { enabledSports } = useSport();
  const coaches = [...new Map(items.filter((o) => o.coach_id).map((o) => [o.coach_id, o.coach_name || "Coach"])).entries()]
    .sort((a, b) => a[1].localeCompare(b[1]));
  const levels = [...new Set(items.map((o) => o.skill_level).filter(Boolean))].sort();
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  return (
    <>
      <div className="label-mono text-[10px]">COACH</div>
      <select value={f.coach} onChange={set("coach")} className={sel} data-testid="filter-coach">
        <option value="">All coaches</option>
        {coaches.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
      </select>
      <div className="label-mono text-[10px]">DATE</div>
      <select value={f.date} onChange={set("date")} className={sel} data-testid="filter-date">
        {DATE_RANGES.map((r) => <option key={r.v} value={r.v}>{r.l}</option>)}
      </select>
      {f.date === "day" && <input type="date" value={f.day} onChange={set("day")} className={sel} data-testid="filter-date-day" />}
      <div className="label-mono text-[10px]">SPORT</div>
      <select value={f.sport} onChange={set("sport")} className={sel} data-testid="filter-sport">
        <option value="">All sports</option>
        {(enabledSports || Object.keys(SPORT_META)).map((s) => <option key={s} value={s}>{SPORT_META[s].label || s}</option>)}
      </select>
      <div className="label-mono text-[10px]">LEVEL</div>
      <select value={f.level} onChange={set("level")} className={sel} data-testid="filter-level">
        <option value="">All levels</option>
        {levels.map((l) => <option key={l} value={l}>{l.charAt(0).toUpperCase() + l.slice(1)}</option>)}
      </select>
    </>
  );
}
